import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-stack" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }

import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressForm',
  props: {
    line_1: { default: "" },
    line_2: { default: "" },
    city: { default: "" },
    state: { default: "" },
    zip: { default: "" },
    lat: { default: null },
    lng: { default: null },
    country_code: { default: null },
    country: { default: null },
    errors: { default: () => ({}) }
  },
  emits: [
  "update:line_1",
  "update:line_2",
  "update:city",
  "update:state",
  "update:zip",
  "update:lat",
  "update:lng",
  "update:country_code",
  "update:country",
],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppTextField, {
          "model-value": __props.line_1,
          label: "Address Line 1",
          "label-icon": "mdi-map-marker-outline",
          placeholder: "123 Main St",
          "error-messages": __props.errors.line_1 ? [__props.errors.line_1] : [],
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:line_1', $event)))
        }, null, 8, ["model-value", "error-messages"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppTextField, {
          "model-value": __props.line_2,
          label: "Address Line 2",
          "label-icon": "mdi-home-outline",
          placeholder: "Suite, Apt, etc.",
          "hide-details": "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:line_2', $event)))
        }, null, 8, ["model-value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppTextField, {
          "model-value": __props.city,
          label: "City",
          "label-icon": "mdi-city-variant-outline",
          placeholder: "New York",
          "error-messages": __props.errors.city ? [__props.errors.city] : [],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:city', $event)))
        }, null, 8, ["model-value", "error-messages"])
      ]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(AppTextField, {
                  "model-value": __props.state,
                  label: "State",
                  "label-icon": "mdi-map-outline",
                  placeholder: "NY",
                  "error-messages": __props.errors.state ? [__props.errors.state] : [],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:state', $event)))
                }, null, 8, ["model-value", "error-messages"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(AppTextField, {
                  "model-value": __props.zip,
                  label: "ZIP",
                  "label-icon": "mdi-mailbox-outline",
                  placeholder: "10001",
                  "error-messages": __props.errors.zip ? [__props.errors.zip] : [],
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:zip', $event)))
                }, null, 8, ["model-value", "error-messages"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})